import { cn } from "@/lib/utils";

export function MaintenanceBanner({ enabled }: { enabled: boolean }) {
  if (!enabled) {
    return <div />;
  }

  return (
    <div
      role="status"
      aria-live="polite"
      className={cn(
        "alert relative rounded-none border-x-0 border-t-0 py-2",
        "alert-warning",
      )}
    >
      <div className="container mx-auto flex justify-center px-4">
        <div className="text-sm leading-tight">
          Scoopulator is undergoing scheduled maintenance. Some features may be
          temporarily unavailable.
        </div>
      </div>
    </div>
  );
}
